import {LOCALE_ID, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LoginComponent} from './pages/login/login.component';
import {DesignTestsComponent} from './pages/design-tests/design-tests.component';
import {HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {MatNativeDateModule} from '@angular/material/core';
import {MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY_PROVIDER} from '@angular/material/datepicker';
import {MAT_SELECT_SCROLL_STRATEGY_PROVIDER} from '@angular/material/select';
import {MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER} from '@angular/material/autocomplete';
import {MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER} from '@angular/material/tooltip';
import {SidenavService} from './app-layout/service/sidenav.service';
import {MAT_CHIPS_DEFAULT_OPTIONS} from '@angular/material/chips';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {ToolbarService} from './app-layout/service/toolbar.service';
import {AppLayoutModule} from './app-layout/app-layout.module';
import {ApiInterceptor} from './infrastructure/interceptor/api-interceptor';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {provideTranslateService, TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {AppFormsModule} from './app-layout/components/forms/app-forms.module';
import {UpdateApplicationService} from './update-application.service';
import {environment} from '../environments/environment';
import {ServiceWorkerModule} from '@angular/service-worker';
import {ComponentsModule} from './app-layout/components/components.module';

import {registerLocaleData} from '@angular/common';
import localePt from '@angular/common/locales/pt';
import {PlanComponent} from './pages/plan/plan.component';
import {ForgotPasswordComponent} from './pages/forgot-password/forgot-password.component';
import {ForgotPasswordResetComponent} from './pages/forgot-password-reset/forgot-password-reset.component';
import {CreateNewAccountComponent} from './pages/create-new-account/create-new-account.component';
import {EmailPreferencesComponent} from './pages/email-preferences/email-preferences.component';
import {ConfirmationDialogModule} from './app-layout/components/others/confirmation-dialog/confirmation-dialog.module';


registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PlanComponent,
    DesignTestsComponent,
    ForgotPasswordComponent,
    ForgotPasswordResetComponent,
    CreateNewAccountComponent,
    EmailPreferencesComponent
  ],
    imports: [
        BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        RouterModule,
        AppLayoutModule,
        MatNativeDateModule,
        MatProgressSpinnerModule,
        AppFormsModule,
        ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production, registrationStrategy: 'registerWhenStable:30000'}),
        ComponentsModule,
        ConfirmationDialogModule,
        TranslateModule.forRoot({
          fallbackLang: 'pt-BR',
          loader: {
            provide: TranslateLoader,
            useFactory: () => [], // Dummy factory, we'll use providers
            deps: [HttpClient]
          }
        })
    ],
  providers: [
    MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY_PROVIDER,
    MAT_SELECT_SCROLL_STRATEGY_PROVIDER,
    MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER,
    MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER,
    SidenavService,
    ToolbarService,
    {
      provide: MAT_CHIPS_DEFAULT_OPTIONS,
      useValue: {
        separatorKeyCodes: [ENTER, COMMA]
      }
    },
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    provideTranslateService({
      defaultLanguage: 'pt-BR'
    }),
    provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json'
    }),
    UpdateApplicationService,
  ],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
